import {
  FETCH_MODELS_DATA_FAILURE,
  FETCH_MODELS_DATA_REQUEST,
  FETCH_MODELS_DATA_SUCCESS,
} from "../actions/realtimeModelsData.actions";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const modelsData = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MODELS_DATA_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_MODELS_DATA_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      };
    case FETCH_MODELS_DATA_FAILURE:
      return {
        ...state,
        data: null,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default modelsData;
